import { useMemo } from "react";
import { formatHoursAndMinutes, hoursToMinutes } from "../../utils/lateHours";
import { summarizePunchMonth } from "../../utils/punchMonthTotals";
import "./PunchMonthTotals.css";

function formatHours(value) {
  return formatHoursAndMinutes(hoursToMinutes(value));
}

function remainingNote(totals) {
  if (totals.hasUnusedOvertime) {
    return "نعم — لسه باقي ساعات في الرصيد التعويضي";
  }
  if (totals.pendingOvertimeHours > 0) {
    return "لا — الإضافي لسه ما اتحولش لرصيد ينفع التحويل منه";
  }
  return "لا — مفيش ساعات إضافي متبقية";
}

export default function PunchMonthTotals({ days, monthTotals }) {
  const totals = useMemo(
    () => summarizePunchMonth(days, monthTotals),
    [days, monthTotals],
  );

  return (
    <section className="punch-month-totals" aria-label="إجمالي الشهر">
      <div className="punch-month-totals-item">
        <span className="punch-month-totals-label">إجمالي ساعات العمل</span>
        <strong className="punch-month-totals-value">
          {formatHours(totals.totalWorkingHours)}
        </strong>
      </div>
      <div className="punch-month-totals-item">
        <span className="punch-month-totals-label">إجمالي الإضافي</span>
        <strong className="punch-month-totals-value">
          {formatHours(totals.overtimeHours)}
        </strong>
      </div>
      <div className="punch-month-totals-item">
        <span className="punch-month-totals-label">أذونات من الإضافي</span>
        <strong className="punch-month-totals-value">
          {formatHours(totals.compensatoryPermitHours)}
        </strong>
      </div>
      <div
        className={`punch-month-totals-item ${
          totals.hasUnusedOvertime ? "is-remaining" : "is-used-up"
        }`}
      >
        <span className="punch-month-totals-label">متبقي من الإضافي</span>
        <strong className="punch-month-totals-value">
          {formatHours(totals.remainingOvertimeHours)}
        </strong>
        <span className="punch-month-totals-note">{remainingNote(totals)}</span>
      </div>
    </section>
  );
}
